
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueAgainstWorkOrderGrid extends _Ext.GridBase<IssueMaterialItemsRow, any> {
        protected getColumnsKey() { return 'Production.IssueAgainstWorkOrder'; }
        protected getDialogType() { return IssueMaterialItemsDialog; }
        protected getIdProperty() { return IssueMaterialItemsRow.idProperty; }
        protected getInsertPermission() { return IssueMaterialItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return IssueMaterialItemsRow.localTextPrefix; }
        protected getService() { return IssueAgainstWorkOrderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
           

            this.setTitle("");
            return grid;
        }


        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle:"Issue Against Work Order"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: IssueAgainstWorkOrderService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}